'use client';
import { CollectionTitle as Shared } from '@launchstore/shared-puck';
export const CollectionTitle: any = Shared;
export default CollectionTitle;
